import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Unsubscribe } from 'app/unsubscribe';
import { UnsubscribeConfiguration } from 'app/unsubscribe/configuration';

/**
 * Report Unsubscribe service is responsible for unsubscribing a report
 */
@Injectable()
export class ReportUnsubscribeService {
    constructor(
        private readonly http: HttpClient,
        private readonly unsubscribeConfiguration: UnsubscribeConfiguration,
    ) {}

    /**
     * Unsubscribe a report
     * @param guid : string
     */
    unsubscribe(guid: string): Observable<Unsubscribe> {
        const url: string = this.unsubscribeConfiguration.apiPaths.unsubscribe(guid);

        return this.http.post<any>(url, null);
    }
}
